// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"2ccfb98c","453":"732d482f","934":"e140e444"}[chunkId] + ".chunk.js";
};